<template>
    <div>
        <h2
            class="text-2xl md:text-32 leading-loose font-bold text-center text-onyx"
        >
            Frequently Asked Questions
        </h2>

        <div v-if="displayedQuestions.length > 0" class="w-full mt-5 mb-10">
            <FAQQuestionList
                :questions="displayedQuestions"
                :has-more="hasMoreQuestions"
                :loading="isLoadingQuestions"
                :active-color="activeColor"
            />
        </div>

        <div class="text-center">
            <p
                v-if="displayedQuestions.length > 0"
                class="text-onyx text-14 md:text-base lg:text-20 font-semibold mb-4"
            >
                Can't find what you are looking for?
            </p>

            <a
                href="/faq"
                class="underline text-14 md:text-base lg:text-18 text-onyx hover:text-primary"
            >
                Visit our FAQs page
            </a>
        </div>
    </div>
</template>

<script>
import FAQQuestionList from './components/FAQQuestionList.vue';
import axios from 'axios';

export default {
    components: {
        FAQQuestionList,
    },
    name: 'FeaturedFaq',
    props: {
        activeColor: {
            type: String,
            default: '#b32026',
        },
    },
    computed: {
        isEmployersPage() {
            return window.location.pathname.includes('work-with-us');
        },
    },
    data() {
        return {
            displayedQuestions: [],
            hasMoreQuestions: false,
            isLoadingQuestions: true,
        };
    },
    mounted() {
        this.getFeaturedQuestions();
    },
    methods: {
        async getFeaturedQuestions() {
            this.isLoadingQuestions = true;
            try {
                let url = '/api/faq/featured-questions';
                if (this.isEmployersPage) {
                    url = '/api/faq/featured-questions-on-employers-page';
                }

                const { data } = await axios.get(url);
                this.displayedQuestions = data.questions;
                this.hasMoreQuestions = false;
            } catch (error) {
                console.error('Error fetching featured questions:', error);
                this.displayedQuestions = [];
            } finally {
                this.isLoadingQuestions = false;
            }
        },
    },
};
</script>
